import { makeStyles } from "@material-ui/core";
import React from "react";
import { DeleteButton, Toolbar as RaToolbar, SaveButton } from "react-admin";
import SafeTag from "../components/SafeTag";
import GenerateUserPaymentButton from "./buttons/GenerateUserPaymentButton";

const useStyles = makeStyles((theme) => ({
	toolbar: {
		paddingLeft: theme.spacing(2),
		justifyContent: "space-between",
		display: "flex",
	},
	button: {
		marginRight: theme.spacing(1),
		overflow: "hidden",
	},
}));

const Toolbar = ({ basePath, permissions, ...props }) => {
	const classes = useStyles();
	return (
		<RaToolbar {...props} className={classes.toolbar}>
			<SaveButton
				className={classes.button}
				redirect="list"
				disabled={props.pristine}
				submitOnEnter={true}
			/>
			{permissions && permissions("admin") && <SafeTag>
				<GenerateUserPaymentButton
					isButton={true}
					variant="contained"
					record={props.record}
				/>
			</SafeTag>}
			{permissions && permissions("admin") && <DeleteButton />}
		</RaToolbar>
	);
};

export default Toolbar;
